module.exports = __webpack_public_path__ + "static/media/vscode.5092e8ce.png";